import React from 'react';
import { Form, Row, Col, Dropdown } from 'react-bootstrap';
import styles from '../AddProducts.module.scss';

const CategorySelect = ({ categories, value, onChange, error, edit }) => {

    const handleCategorySelect = (categoryId) => {
        const selected = categoryId ? categories.find(cat => String(cat.id) === String(categoryId)) : null;
        onChange({
            target: {
                name: 'selectedCategoryId',
                value: categoryId,
                category: selected ? selected.category : ''
            }
        });
    };

    return (
        <Form.Group as={Row} className='mb-3'>
            <Form.Label column sm={3}>
                Product Category <span className='text-danger'>*</span>
            </Form.Label>
            <Col sm={9}>
                <Dropdown className="w-100">
                    <Dropdown.Toggle
                        variant='light'
                        className={`form-select text-start ${styles.noCaret} w-100 ${error ? 'is-invalid' : ''}`}
                        id='category-select'
                        defaultValue={edit ? value : null}
                    >
                        {(() => {
                            if (edit && value) return value;
                            const selected = value ? categories.find(cat => String(cat.id) === String(value)) : null;
                            return selected ? selected.category : 'Select a Product category';
                        })()}
                    </Dropdown.Toggle>

                    <Dropdown.Menu className={styles.dropdownMenu}>
                        <div className={styles.scrollableMenu}>
                            <Dropdown.Item
                                key="none"
                                active={!value}
                                onClick={() => handleCategorySelect('')}

                            >
                                Select a Product category
                            </Dropdown.Item>
                            {categories.map((category) => (
                                <Dropdown.Item
                                    key={category.id}
                                    active={String(value) === String(category.id)}
                                    onClick={() => handleCategorySelect(category.id)}
                                >
                                    {category.category}
                                </Dropdown.Item>
                            ))}
                            {categories.length === 0 && (
                                <div className={styles.noMatches}>No categories available</div>
                            )}
                        </div>
                    </Dropdown.Menu>
                </Dropdown>
                {error && (
                    <div className="invalid-feedback">
                        {error}
                    </div>
                )}
            </Col>
        </Form.Group>
    );
};

export default CategorySelect;
